module.exports = __webpack_public_path__ + "media/images/admin/icons/chevrons-left-13ee170446da2ec160bded549df59974.svg";